import { renderGoogleButton } from './GoogleLogin.js';
import { csrfToken } from './csrf.js';
import * as journal from './journal.js';
import AccountManager from './accountManager.js';
import AccountsPage from './accounts.js';
import AIUI from './aiUI.js';
import Dashboard from './dashboard.js';
import Help from './help.js';
import InstallMT5 from './installMT5.js';
import Pricing from './pricing.js';
import Privacy from './privacy.js';
import Profile from './profile.js';
import Terms from './terms.js';
import tradeData from './tradeData.js';
import tradeJournal from './tradeJournal.js';
import TradingStrategies from './tradingStrategies.js';
import Calendar from './calendar.js';
import { scanner } from './scanner.js';
import Inspiration from './inspiration.js';
import RiskCalculator from './riskCalculator.js';
import Simulator from './simulator.js';
import Analytics from './analytics.js';
import Charts from './charts.js';
import Level from './level.js';
import AccountGrowth from './accountGrowth.js';
import Report from './report.js';

export default abstract class App {
	public static async init() {
		Profile.applySavedTheme();
		Inspiration.init();
		RiskCalculator.init();
		
		if (window.user == null) { renderGoogleButton('google-btn'); }
		else { 
			App.initHeaderButtons(); 
			await AccountManager.init();
		}
		
		if (window.location.pathname.startsWith('/journal/quick/')) { await tradeJournal.initQuick(); }
		else if (window.location.pathname === '/journal') { journal.default.init(); }
		else if (window.location.pathname === '/charts') { Charts.init(); }
		else if (window.location.pathname === '/trade-data') { tradeData.init(); }
		else if (window.location.pathname === '/calendar') { Calendar.init(); }
		else if (window.location.pathname === '/profile') { Profile.init(); }
		else if (window.location.pathname === '/simulator') { Simulator.init(); }
		else if (window.location.pathname === '/analytics') { Analytics.init(); }
		else if (window.location.pathname === '/pricing') { Pricing.init(); }
		else if (window.location.pathname === '/analysis') { AIUI.init(); }
		else if (window.location.pathname === '/playbooks') { TradingStrategies.init(); } // UNIT-77: TV /strategies remounts at /playbooks (avoids the host /strategies collision)
		else if (window.location.pathname === '/scanner') { scanner.init(); }
		else if (window.location.pathname === '/accounts') { AccountsPage.init(); }
		else if (window.location.pathname === '/privacy') { Privacy.init(); }
		else if (window.location.pathname === '/terms') { Terms.init(); }
		else if (window.location.pathname === '/install-mt5') { InstallMT5.init(); }
		else if (window.location.pathname === '/help') { Help.init(); }
		else if (window.location.pathname === '/level') { Level.init(); }
		else if (window.location.pathname === '/account-growth') { AccountGrowth.init(); }
		else if (window.location.pathname === '/report') { Report.init(); }
		else if (window.location.pathname === '/dashboard' || window.location.pathname === '/') { Dashboard.init(); }
	}
	
	private static initHeaderButtons() {
		const logoutBtns = [document.getElementById('logout-btn'), document.getElementById('logout-btn-menu')];
		const hamburgerBtn = document.getElementById('hamburger-btn');
		const floatingMenu = document.getElementById('floating-menu');
		
		if (hamburgerBtn && floatingMenu) {
			hamburgerBtn.addEventListener('click', (e) => {
				e.stopPropagation();
				floatingMenu.classList.toggle('open');
			});

			document.addEventListener('click', (e) => {
				if (floatingMenu.classList.contains('open') && !floatingMenu.contains(e.target as Node)) {
					floatingMenu.classList.remove('open');
				}
			});
		}

		logoutBtns.forEach(btn => {
			if (btn) {
				btn.addEventListener('click', async (e) => {
					e.preventDefault();
					await fetch('/auth/logout', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() }
					});
					
					localStorage.removeItem('selectedAccount');
					if (window.google) { window.google.accounts.id.disableAutoSelect(); }
					
					window.location.href = '/';
				});
			}
		});
	}
}
